<template>
  
  <div class="chartTemp">
      <div class="chartItemTitulo">Temperatura</div>
    <div class="chartItemIcone">
      <i class="fas fa-thermometer-quarter"></i>
    </div>
    <div class="chartItemValor">12º C </div>
  </div>

</template>

<script>

export default {
    name: 'ChartTemp'
}
</script>

<style>
.chartTemp {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
</style>